import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { destinations } from '../mock';
import { slugify } from '../data';

function SectionHead({ eyebrow, title, sub }) {
  return (
    <div className="max-w-3xl mb-12 reveal">
      <p className="section-eyebrow mb-3"><span className="h-px w-8 bg-[#EA5019] inline-block" /> {eyebrow}</p>
      <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-[#0B2545] leading-tight">{title}</h2>
      {sub && <p className="mt-4 text-slate-500 leading-relaxed">{sub}</p>}
    </div>
  );
}

export { SectionHead };

export default function Destinations() {
  return (
    <section id="destinations" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHead
          eyebrow="EXPLORE THE WORLD"
          title="Destinations Across Every Corner of the World."
          sub="Choose from carefully curated destinations across India and the world. Whether you're dreaming of mountains, beaches, heritage cities or once-in-a-lifetime adventures, every journey starts here."
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {destinations.map((d, i) => (
            <Link
              key={d.name}
              to={`/destinations/${slugify(d.name)}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] reveal shadow-[0_10px_30px_rgba(11,37,69,0.08)]"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              <img src={d.img} alt={d.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/85 via-[#0B2545]/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 flex items-end justify-between">
                <h3 className="font-heading text-white text-lg md:text-xl font-bold">{d.name}</h3>
                <span className="grid place-items-center h-9 w-9 rounded-full bg-white/15 backdrop-blur-sm text-white translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
